import SearchForm from "./search"
import Pagination from "@/components/curd/pagination"
import PageData from "@/components/curd/pagination/data.js"
import Table from "./table"
import Detial from '@/components/Detial/index.vue'
import {message} from 'ant-design-vue';
import {updateContract,exportall,multiout} from "@/api/contract.js"
import {excelheader} from './data.js';
import downloadexcel from "vue-json-excel";
// import {getTotalMoney} from '@/components/getTotalMoney.js'
import SumComponent from './sum';
import Leave from './leave';


function getTotalMoney(data){
	let {rows,pricesum,pricesum0,pricesum1,peoplenum,peoplenum1,peoplenum0} = data
	let peosum = [],peosum1 =[]
	let pagesum = rows.reduce((total,item)=>{ 
		if(item.type != 5){
			if(item.isMoneyGive == 0){
				total.num0 += (parseFloat(item.price)||0)
			}else{
				total.num1 += (parseFloat(item.price)||0)
			}
		}
		if(item.type==4&&item.yiOuttime){
			if(!peosum1.find(i=>i.yi==item.yi)){
				peosum1.push(item)
				total.people1++
			}
		}
		if(item.type == 4){
			if(!peosum.find(i=>i.yi==item.yi)){
				peosum.push(item)
				total.people++
			}
		}
		return total
	},{num0:0,num1:0,people:0,people1:0})
	pagesum.num = parseFloat(pagesum.num0)+parseFloat(pagesum.num1)
	pagesum.people0 = pagesum.people - pagesum.people1
	return {pagesum,pricesum,pricesum0,pricesum1,peoplenum,peoplenum0,peoplenum1}
}

export default {
	data(){
		return {
			sumdata:{pagesum:{}},
			detialId:-1,
			detialshow:false,
			excelheader,
		}
	},
	methods:{
		getsearchdata(){
			let searchdata = this.$refs.searchref.getformdata()
			return searchdata
		},
		getlist(parm){
			let data = {status:3,...this.getsearchdata(),current:this.current,pageSize:this.pageSize,...parm}
			this.$refs.tableref.getlist(data).then(ret=>{
				this.total = ret.count
				this.current = data.current
				this.pageSize = data.pageSize
				let dd = getTotalMoney(ret)
				this.sumdata = {...dd} 
			})
		},
		//详情相关
		godetial(id){
			this.detialId = id
			this.detialshow = true
		},
		backdetial(){
			this.detialshow = false
		},
		confirmfn(id,type){
			let hide = message.loading("正在操作中",100)
			updateContract({id,confirm:1,type}).then(ret=>{
				hide()
				if(ret.code == 0){
					this.getlist()
					message.success("操作成功",1)
				}else{
					message.error("操作失败",1)
				}
			})
		},
		async getAllData(){
			message.loading({content:"正在导出",key:"daochu"})
			let parm = this.getsearchdata()
			let {isMoneyGive,yiOuttime } = parm
				if(isMoneyGive){
					parm = {...parm,isMoneyGive:isMoneyGive-1}
				}
				if(yiOuttime){
					parm = {...parm,yiOuttime:yiOuttime-1,type:4}
				}
			let {code,data} = await exportall(parm)
			if(code == 0){
				return data
			}
			return false
		},
		exportsuccess(){
			message.success({content:"导出成功",key:"daochu",duration:2})
		},
		getdataSource(){
			message.loading({content:"正在导出",key:"daochu"})
			let data = this.$refs.tableref.getdataSource()
			return data
		},
		showleave(){
			let slts = this.$refs.tableref.getSlts()
			if(slts.length == 0){
				message.error("请选择要操作的数据")
				return;
			}
			this.$refs.leaveref.showModal()
		},
		//批量离场
		multioutfn(value){
			let hide = message.loading("正在操作中",1000)
			return multiout({ids:this.$refs.tableref.getSlts(),yiOuttime:value}).then(ret=>{
				hide()
				if(ret.code == 0){
					message.success("操作成功",1)
					this.getlist()
					this.$refs.tableref.setSlts([])
				}else{
					message.error("操作失败",1)
				}
				return "complete"
			})
		}

	},
	components:{
		SearchForm,Table,Pagination,Detial,downloadexcel,SumComponent,Leave
	},
	mounted(){
		this.getlist()
	},
	mixins:[PageData]
}